// Visual Testing (VT) Types

export type VTObjectType = 'Component' | 'Weld' | 'Surface'
export type VTStatus = 'Accepted' | 'Not Accepted'
export type VTMaterialType = 'Carbon steel' | 'Stainless steel' | 'Aluminium'

export const VT_TEST_SITES = ['Bergen', 'Mongstad', 'Ågotnes'] as const
export type VTTestSite = (typeof VT_TEST_SITES)[number]
export const VT_DEFAULT_TEST_SITE: VTTestSite = 'Bergen'

export const VT_EQUIPMENT_OPTIONS = [
  'Torch, Weld Gauge MI-WG-8 / Mirror',
  'Endoscopes, boroscopes, fibre optics or TV cameras',
] as const

export type VTEquipmentType = (typeof VT_EQUIPMENT_OPTIONS)[number]

export interface VTEquipmentSettings {
  equipmentUsed: VTEquipmentType
  equipmentSerialNo: string
  lighting: string
}

export interface VTInspector {
  id: string
  first_name: string
  last_name: string
  certification_number?: string
  vt_level?: number
  user_id?: string
}

export interface VTCompany {
  id: string
  name: string
  report_code: string | null
}

export interface VTReportData {
  testDate: string
  testSite?: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: VTStatus
  objectType: VTObjectType
  equipmentSettings: VTEquipmentSettings
  certificationNumber: string
  sequenceNumber: string
  extentOfExamination: string
  material: VTMaterialType
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
}

export interface VTFormData {
  testDate: string
  testSite: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: VTStatus
  objectType: VTObjectType
  equipmentSettings: VTEquipmentSettings
  extentOfExamination: string
  material: VTMaterialType
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
}

export const DEFAULT_VT_EQUIPMENT: VTEquipmentSettings = {
  equipmentUsed: 'Torch, Weld Gauge MI-WG-8 / Mirror',
  equipmentSerialNo: '---',
  lighting: '500 Lux min.',
}
